import { Component, OnInit, Input, ViewEncapsulation, Inject} from '@angular/core';
import { WarehouseService } from 'src/app/assabil-sales/services/warehouse-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';
import { BaseEntity } from 'src/app/tools/models/baseEntity';

@Component({
    selector: 'warehouse-transfer-type-modal',
    templateUrl: './warehouse-transfer-type-modal.component.html',
    styleUrls: ['./warehouse-transfer-type-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class WarehouseTransferTypeModal extends GenericLovComponent{

    @Input() title  : string  = "Type de Demande de Transfert";

    periodActiveDay       : Date;

    constructor(
      public dialogRef: MatDialogRef<WarehouseTransferTypeModal>, @Inject(MAT_DIALOG_DATA) public data: any,
        protected warehouseService      : WarehouseService,
        protected leanUtilsService      : LeanUtilsService,
        public    userService           : UserService) {
        super();
      this.title  = data.title;
    }

  loadData(): void {
  }

  sordersProcessing(){
    if (! this.periodActiveDay){
      this.leanUtilsService.error("Prière de préciser la date souhaitée");
      return;
    }
    this.warehouseService.sordersProcessing(this.periodActiveDay).then(res => {
      this.leanUtilsService.success();
      this.close();
    })
  }

  returnWt : boolean
  validate(returnWt : boolean) {
    this.returnWt = returnWt;
    this.closeModal(null);
  }

  
  closeModal(dummy : BaseEntity){
    this.dialogRef.close(this.returnWt);
  }

    
}
